<div class="page-container">
  <app-message *ngFor="let message of messages" [message]="message"></app-message>
  <app-loader *ngIf="generatingFlashcards" [text]="'Deine Lernkarten werden erstellt...'"></app-loader>

  <div *ngIf="flashcards.length > 0" class="flashcards-container">
    <div class="done-widget">
      <i class="fas fa-check-circle"></i>
      <span>{{flashcards.length}} Lernkarten generiert</span>
      <app-button [size]="'small'" [text]="'Ansehen'" [style]="'outlined'" (clickEvent)="displayFlashcards()"></app-button>
    </div>
  </div>

  <div class="footer">
    <div class="input-wrapper">
      <textarea [(ngModel)]="text" [placeholder]="'Nachricht eingeben'" (keydown.enter)="handleSend(); $event.preventDefault()"></textarea>
      <button type="submit" (click)="handleSend()" [disabled]="text.length === 0"><i class="fas fa-circle-up" [class.primary-color]="text.length > 0"></i></button>
    </div>    
  </div>

  <app-bottom-dialog [isVisible]="showFlashcards" [title]="'Erstellte Lernkarten'" (actionCancelled)="showFlashcards = false">
    <div class="flashcard-view-content">
      <app-flashcard-list [flashcards]="flashcards"></app-flashcard-list>
    </div>
    <div *ngIf="showFlashcards" class="dialog-footer">
      <app-button [loading]="isSavingFlashcards" [text]="'Lernkarten übernehmen'" (clickEvent)="saveFlashcards()"></app-button>
    </div>
  </app-bottom-dialog>
</div>